export default function ConfirmModal({
  open,
  title,
  description,
  risk = 'low',
  requireNote = false,
  note = '',
  onNoteChange,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="wb-modal-backdrop">
      <div className={`wb-modal ${risk === 'high' ? 'risk-high' : ''}`}>
        <h3>{title}</h3>
        <p>{description}</p>
        {requireNote && (
          <textarea
            value={note}
            onChange={(e) => onNoteChange?.(e.target.value)}
            placeholder="Reason for this action"
            rows={4}
          />
        )}
        <div className="wb-modal-actions">
          <button type="button" onClick={onCancel}>Cancel</button>
          <button type="button" className={risk === 'high' ? 'danger' : ''} onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
